<app-navbar-control></app-navbar-control>

<div class="home-details">

  <app-hero-section></app-hero-section>

  <app-meet-clockflex></app-meet-clockflex>

  <app-who-can-benifit></app-who-can-benifit>

  <app-how-it-work></app-how-it-work>

  <app-features></app-features>

  <app-testimonials></app-testimonials>

  <app-contact-section></app-contact-section>

  <app-footer></app-footer>
</div>

<ng-template #getInTouchWithUSModel aria-modal="true" let-modal>
  <app-get-in-touch-with-us (closeModal)="closeModal($event)"></app-get-in-touch-with-us>
</ng-template>